import { recordError } from './buffers';

/**
 * Gestionnaires d'erreurs GLOBAUX (à appeler au boot, AVANT le rendu — cf.
 * `main.tsx`). Capturent les exceptions non interceptées et les rejets de promesse
 * non gérés dans l'anneau d'erreurs. Idempotent (installé une seule fois).
 */

let installed = false;

function messageOfReason(reason: unknown): { message: string; stack?: string } {
  if (reason instanceof Error) {
    return { message: reason.message, ...(reason.stack ? { stack: reason.stack } : {}) };
  }
  return { message: typeof reason === 'string' ? reason : String(reason) };
}

export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event: ErrorEvent) => {
    const stack = event.error instanceof Error ? event.error.stack : undefined;
    recordError(event.message || 'Erreur non interceptée', 'exception', stack);
  });

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const { message, stack } = messageOfReason(event.reason);
    recordError(message, 'rejection', stack);
  });
}
